import httpClient from '@/utilities/service/httpClient'
// eslint-disable-next-line prettier/prettier
import type { LoginResponseType } from '@/api/types/response/AuthType'

export default class AuthApi {
  login(): Promise<LoginResponseType> {
    return httpClient.post('login')
  }
}
